export default __webpack_public_path__ + "static/silverLDetail-376c46daa903c23ee74a1a0cf9aa0a18.png";